var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner-container"},[_c('div',{staticClass:"section-title budget"},[_vm._v("* Under construction now *")])])}]

export { render, staticRenderFns }